import { render, staticRenderFns } from "./ShowPostStatus.vue?vue&type=template&id=547dc17f"
import script from "./ShowPostStatus.vue?vue&type=script&lang=js"
export * from "./ShowPostStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports